var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgM333(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 57,
    viewBox: "0 0 115 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.036 0c.049 17.743.103 35.485.132 53.229.002.688-.224 1.377-.409 2.444H60.656V16.566l-.81-.403c-.81.83-1.686 1.607-2.419 2.499-9.382 11.41-18.732 22.847-28.128 34.247-.923 1.12-2.092 2.042-3.58 2.636 4.101-7.063 9.793-12.838 14.765-19.421V22.5c-5.6 5.587-9.49 11.697-15.005 17.238l-14.853-18.13v33.657c-3.799 1.349-7.228.75-10.626.611V4.298h9.392c6.251 6.162 10.468 13.223 16.597 18.894L41.473 4.766h10.438c.079 5.593.15 10.74.221 15.885l.96.238L70.17 0h.866zM79.996 5.303h32.497c-2.295 6.75-5.472 12.595-8.442 19.005 7.567 4.123 11.48 10.245 10.478 18.929-.388 3.364-1.444 6.32-4.904 8.623l-6.385-7.515c-.642-9.812-.731-9.922-10.371-12.775l-2.84-3.588 5.689-12.237H79.996V5.303z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgM333);
export default __webpack_public_path__ + "static/media/m333.31a7b408489011e045ba1d2c6b711e10.svg";
export { ForwardRef as ReactComponent };